import React, { Component } from "react";
import { connect } from "react-redux";
import { push } from "connected-react-router";
import { sendNotification } from "src/redux/actions/notifications";
import { addTailoring, deleteTailoring, findAllTailoring } from "src/redux/actions/tailoring";
import { withRouter, Link } from "react-router-dom";
import { findAllSites } from 'src/redux/actions/sites';
import { addStock, deleteStock, findAllStock } from 'src/redux/actions/stock';
import { findAllUsers } from 'src/redux/actions/admin';

class Tailoring extends Component {
  render = () => {
    const {
      Layout,
      tailoring,
      user,
      findAllTailoring,
      addTailoring,
      deleteTailoring,
      findAllSites,
      sites,
      stock,
      findAllStock,
      findAllUsers,
      users,
      addStock,
      deleteStock,
      sendNotification,
      push,
      history,
      findAllTailoringUpdatedToday,
    } = this.props;
    return (
      <Layout
        tailoring={tailoring}
        user={user}
        users={users}
        addTailoring={addTailoring}
        stock={stock}
        findAllStock={findAllStock}
        findAllUsers={findAllUsers}
        addStock={addStock}
        deleteStock={deleteStock}
        findAllTailoring={findAllTailoring}
        deleteTailoring={deleteTailoring}
        sendNotification={sendNotification}
        findAllSites={findAllSites}
        sites={sites}
        push={push}
        history={history}
      />
    );
  };
}

const mapStateToProps = state => ({
  tailoring: state.tailoring.allTailoring || [],
  stock: state.stock.allStock || [],
  sites: state.sites.allSites,
  users: state.admin.allUsers || [],
  user: state.user.user || {},
});

const mapDispatchToProps = {
  findAllStock,
  findAllUsers,
  addStock,
  deleteStock,
  addTailoring,
  deleteTailoring,
  findAllTailoring,
  sendNotification,
  findAllSites,
  push,
};

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(Tailoring)
);
